import { apiInterfaceForJson } from "../common/apiManager";

export const fetchUsers = () => {
    return apiInterfaceForJson("/user/v1/", "GET");
};

export const fetchAvailableUsers = () => {
    return apiInterfaceForJson("/user/v1/available", "GET");
};

export const searchUsers = (query) => {
    return apiInterfaceForJson("/user/v1/search", "POST", query);
};

export const getUserDataById = (userId) => {
    return apiInterfaceForJson("/user/v1/" + userId, "GET");
};

export const getAgentDataById = (userId) => {
    return apiInterfaceForJson("/user/v1/agent/" + userId, "GET");
};

export const createUser = (userDetails) => {
    return apiInterfaceForJson("/user/v1/", "POST", { user: userDetails });
};

export const registerUser = (userDetails) => {
    return apiInterfaceForJson("/user/v1/register", "POST", { user: userDetails });
};

export const updateUser = (userDetails) => {
    return apiInterfaceForJson("/user/v1/update", "POST", userDetails);
};

export const updateUserBackgroundThemeColor = (userDetails) => {
    return apiInterfaceForJson("/user/v1/update", "POST", userDetails);
};

export const updateDevice = (deviceDetails) => {
    let userDeviceInfo = {
        _id: deviceDetails.id,
        device_id: deviceDetails.deviceId
    };
    return apiInterfaceForJson("/user/v1/updateDevice", "POST", userDeviceInfo);
};

export const deleteUser = (userDetails) => {
    return apiInterfaceForJson("/user/v1/delete", "POST", userDetails);
};


// export const saveCallLog = (callLog) => {
//     return apiInterfaceForJson("/user/v1/saveCallLog", "POST", callLog);
// };

export const bulkUpdateUsers = (updateData) => {
    return apiInterfaceForJson("/user/v1/bulk-update", "POST", updateData);
};

export const getUserPerformance = (userId, timeRange = "today") => {
    return apiInterfaceForJson(`/user/v1/${userId}/performance?timeRange=${timeRange}`, "GET");
};

// Fast Login Functions
export const generateFastLoginToken = (userId) => {
    return apiInterfaceForJson("/user/v1/generateFastLoginToken", "POST", { userId });
};

export const authenticateWithFastLoginToken = (token) => {
    return apiInterfaceForJson("/user/v1/authenticateWithToken", "POST", { token });
};

export const revokeFastLoginToken = (userId) => {
    return apiInterfaceForJson("/user/v1/revokeFastLoginToken", "POST", { userId });
};

export const commpeakMakeCall = (callData) => {
    return apiInterfaceForJson("/user/v1/commpeakCall", "POST", callData);
};

export const voisoMakeCall = (callData) => {
    return apiInterfaceForJson("/user/v1/voisoCall", "POST", callData);
};
